module.exports = function() {
  return new Worker(__webpack_public_path__ + "d970144b0a8803dfc174.worker.js");
};